<template>
<div id="app">
  <router-view :key="$route.path" />
</div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
@import './assets/variables.scss';
#app {
    font-family: Arial, FontAwesome;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
